module.exports = __webpack_public_path__ + "static/media/banff-41.f1eca28c.jpg";